import React, { useMemo } from 'react'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { getDistanceUnit, getOfferBasedLereState } from 'selectors/recommendations'
import YmalStickyFooter, { Props as YmalStickyFooterProps } from '../StickyFooter/YmalStickyFooter'
import uuidV4 from 'lib/uuidV4'
import TrackingContext, { TrackingProps } from 'contexts/trackingContext'

interface Props extends YmalStickyFooterProps {
  seedOffer: App.BedbankOffer
}

function BedbankYmalStickyFooter(props: Props) {
  const {
    lereVersion,
  } = props

  const stickyFooterTracking = useMemo<TrackingProps>(() => ({
    category: 'Recommendations',
    label: 'V1 - LPP - Sticky Footer',
    listId: uuidV4(),
    listName: 'Recommendations - V1 - LPP - Sticky Footer',
    ...(lereVersion ? { lere: { version: lereVersion } } : {}),
  }), [lereVersion])

  return (
    <TrackingContext.Provider value={stickyFooterTracking}>
      <YmalStickyFooter
        {...props}
      />
    </TrackingContext.Provider>
  )
}

export default withOfferPageAndReduxState((state, appState) => {
  const offerBasedLereState = getOfferBasedLereState(appState, state.bedbankOffer)
  return {
    currency: appState.geo.currentCurrency,
    distanceUnit: getDistanceUnit(appState),
    offerIds: offerBasedLereState.offerIds,
    loadingState: offerBasedLereState.loadingState,
    loadingError: offerBasedLereState.loadingError,
    lereVersion: offerBasedLereState.lereVersion,
    hasEnoughRecommendationsToDisplay: offerBasedLereState.hasEnoughRecommendationsToDisplay,
  }
})(BedbankYmalStickyFooter)
